// extracted by mini-css-extract-plugin
export default {"layout":"CalculatorLayout_layout__gsa-7","main":"CalculatorLayout_main__RsciW"};